import React from 'react';

import { DatevAccountFormAdvice } from 'modules/bookkeep/components/DatevAccountFormAdvice/DatevAccountFormAdvice';

import {
  type IntegrationStatus,
  type IntegrationStatusWithIntegration,
} from '../../../integration/status';
import { getAccountingCodesLength } from '../util/datev';

interface Props {
  className: string;
  integrationStatus: IntegrationStatusWithIntegration | IntegrationStatus;
  showError: boolean;
}

export const BankAccountAdvice = ({
  className,
  integrationStatus,
  showError,
}: Props) => {
  switch (integrationStatus.integration) {
    case 'Datev': {
      return (
        <DatevAccountFormAdvice
          accountLength={
            getAccountingCodesLength(
              integrationStatus.descriptor.settingsAccountingHeaderFields,
            ).expenseAccountLength
          }
          isAlert={showError}
          className={className}
        />
      );
    }
    default:
      return null;
  }
};
